export class ListItem<T> {
	constructor(
		public value: T,
		public text: string
	) {}
}
